<template>
    <h2 class="mb-[20px] sm:mb-[40px]">Cerca l'auto</h2>
    <div class="inline-block w-full mb-[20px]">
        <label class="font-light block mb-[5px]">Pubblicazione Eurotax del:</label>
        <select :disabled="isSelectDataDisabled"
            :class="{ 'disabled': isSelectDataDisabled }" v-model="dataPubblicazione" @change="setDataPubblicazione">
            <option v-for="(pubb, index) in periodi" :key="index" :value="`${pubb?.mese}/${pubb?.anno}`">
                {{ pubb?.descrizione }}
            </option>
        </select>
    </div>

    <div class="h-[1px] bg-[#e96932] block w-full relative text-center mb-[20px]"></div>

    <Popup v-if="isNoDataPopupOpen" title="Veicolo non trovato" :data="datiVeicoloNonDisponibile" @close="isNoDataPopupOpen = false" />

    <div class="flex justify-between flex-wrap">
        <div v-if="mainStore?.abbonato?.ricercaTarga?.includes('Auto')" class="inline-block w-full sm:w-[48%] mb-[20px]">
            <label>Targa:</label>
            <input type="text" v-model="targa" placeholder="Targa" @input="onSearchTarga" />
            <div v-if="isLicensePlatesListVisible && vehicleSearched?.versioniBase?.length > 0"
                class="bg-white block border border-[#ccc] border-t-0 w-full rounded-[10px] z-[1] max-h-[200px] overflow-auto shadow-[0_3px_6px_rgba(0,0,0,0.16)]">
                <ul v-if="vehicleSearched?.versioniBase?.length > 0" class="list-none block w-full text-sm m-0 p-0">
                    <li v-for="(item, index) in vehicleSearched.versioniBase" :key="index" class="list-none block w-full cursor-pointer m-0 p-0 hover:bg-[#ccc]" @click="saveVehicle(item)">
                        <div class="block w-full text-black text-left border border-top-[#ccc] m-0 py-[8px] px-[15px]">
                            {{ item?.versioneBase?.descrizione }} ({{ format(item?.inizioProduzione, "YYYY-MM-DD", "MM/YYYY") }} - {{ format(item?.fineProduzione, "YYYY-MM-DD", "MM/YYYY") }})
                        </div>
                    </li>
                </ul>
            </div>
        </div>
        <!--<div class="inline-block w-[48%] mb-[20px]">
            <label>Telaio:</label>
            <input type="text" v-model="telaio" placeholder="Telaio" @input="onSearchInput('telaio')" />
            <div v-if="isShellsListVisible && vehicleSearched?.versioniBase?.length > 0" 
                class="bg-white block border border-[#ccc] border-t-0 w-full rounded-[10px] z-[1] max-h-[200px] overflow-auto shadow-[0_3px_6px_rgba(0,0,0,0.16)]">
                <ul class="list-none block w-full text-sm m-0 p-0">
                    <li v-for="(item, index) in vehicleSearched.versioniBase" :key="index" class="list-none block w-full cursor-pointer m-0 p-0 hover:bg-[#ccc]" @click="saveVehicle(item)">
                        <div class="block w-full text-black text-left border border-top-[#ccc] m-0 py-[8px] px-[15px]">
                            {{ item?.descrizione }}
                        </div>
                    </li>
                </ul>
            </div>
        </div>-->
        <div class="inline-block w-full sm:w-[48%] mb-[20px]">
            <label>Codice Mnet o Eurotax:</label>
            <input type="text" v-model="codiceMnet" placeholder="Codice Mnet o Eurotax" @input="onSearchEurotax" />
            <div v-if="isEurotaxCodesListVisible && vehicleSearched?.versioniBase?.length > 0" 
                class="bg-white block border border-[#ccc] border-t-0 w-full rounded-[10px] z-[1] max-h-[200px] overflow-auto shadow-[0_3px_6px_rgba(0,0,0,0.16)]">
                <ul class="list-none block w-full text-sm m-0 p-0">
                    <li v-for="(item, index) in vehicleSearched.versioniBase" :key="index" class="list-none block w-full cursor-pointer m-0 p-0 hover:bg-[#ccc]" @click="saveVehicle(item)">
                        <div class="block w-full text-black text-left border border-top-[#ccc] m-0 py-[8px] px-[15px]">
                            {{ item?.versioneBase?.descrizione }} ({{ format(item?.inizioProduzione, "YYYY-MM-DD", "MM/YYYY") }} - {{ format(item?.fineProduzione, "YYYY-MM-DD", "MM/YYYY") }})
                        </div>
                    </li>
                </ul>
            </div>
        </div>
        <div class="inline-block w-full sm:w-[48%] mb-[20px]">
            <label>Codice Costruttore:</label>
            <input type="text" v-model="codiceCostruttore" placeholder="Codice Costruttore" @input="onSearchCostruttore" />
            <div v-if="isMotornetCodesListVisible && vehicleSearched?.versioniBase?.length > 0" 
                class="bg-white block border border-[#ccc] border-t-0 w-full rounded-[10px] z-[1] max-h-[200px] overflow-auto shadow-[0_3px_6px_rgba(0,0,0,0.16)]">
                <ul class="list-none block w-full text-sm m-0 p-0">
                    <li v-for="(item, index) in vehicleSearched.versioniBase" :key="index" class="list-none block w-full cursor-pointer m-0 p-0 hover:bg-[#ccc]" @click="saveVehicle(item)">
                        <div class="block w-full text-black text-left border border-top-[#ccc] m-0 py-[8px] px-[15px]">
                            {{ item?.versioneBase?.descrizione }} ({{ format(item?.inizioProduzione, "YYYY-MM-DD", "MM/YYYY") }} - {{ format(item?.fineProduzione, "YYYY-MM-DD", "MM/YYYY") }})
                        </div>
                    </li>
                </ul>
            </div>
        </div>
    </div>
    
    <div class="flex justify-end mt-[10px] sm:mt-0">
        <button class="button sm:mt-[20px] p-[15px] sm:p-[20px]" @click="searchVehicle">Ricerca</button>
    </div>

    <div class="block w-full relative text-center my-[20px]">
        <div class="absolute top-[50%] w-full h-[1px] bg-[#e96932] block"></div>
        <span class="bg-[#f8f9fa] relative px-[20px]">Oppure</span>
    </div>

    <div class="flex justify-between flex-wrap mb-[20px]" id="selection">
        <div v-if="isImmatricolazioneEstera && targaEstero" class="inline-block w-full sm:w-[48%] mb-[20px]">
            <label class="font-bold block mb-[5px]">
                Targa Estera
            </label>
            <input type="text" class="disabled bg-[#fff]" disabled v-model="targaEstero" />
        </div>
        <div v-if="isImmatricolazioneEstera && statoEstero" class="inline-block w-full sm:w-[48%] mb-[20px]">
            <label class="font-bold block mb-[5px]">
                Stato Estero
            </label>
            <input type="text" class="disabled bg-[#fff]" disabled v-model="statoEstero" />
        </div>
        <div v-if="isImmatricolazioneEstera && dataImmatricolazioneEstero" class="inline-block w-full mb-[20px]">
            <label class="font-bold block mb-[5px]">
                Data immatricolazione Estera
            </label>
            <input type="text" class="disabled bg-[#fff]" disabled v-model="dataImmatricolazioneEstero" />
        </div>
        <div class="inline-block w-full sm:w-[48%] mb-[20px]">
            <label class="font-bold block mb-[5px]">
                <span class="inline-block text-center font-light w-[24px] h-[24px] mr-[3px]">1 -</span>Marca
            </label>
            <select :disabled="isSelectMarcaDisabled" 
                :class="{ 'disabled': isSelectMarcaDisabled }" v-model="marca" @change="setMarca">
                <option value="">Seleziona</option>
                <option v-for="(marca, index) in marche" :key="index" :value="marca?.acronimo">
                    {{ marca?.nome }}
                </option>
            </select>
        </div>
        <div class="hidden sm:inline-block w-[48%] mb-[20px]"></div>
        <div class="inline-block w-full sm:w-[48%] mb-[20px]">
            <label class="font-bold block mb-[5px]">
                <span class="inline-block text-center font-light w-[24px] h-[24px] mr-[3px]">2 -</span>Anno prima immatricolazione
            </label>
            <select :disabled="isSelectAnnoDisabled"
                :class="{ 'disabled': isSelectAnnoDisabled }" v-model="anno" @change="setAnno">
                <option value="">Seleziona</option>
                <option v-for="(anno, index) in anni" :key="index" :value="anno">
                    {{ anno }}
                </option>
            </select>
        </div>
        <div class="inline-block w-full sm:w-[48%] mb-[20px]">
            <label class="font-bold block mb-[5px]">
                <span class="inline-block text-center font-light w-[24px] h-[24px] mr-[3px]">3 -</span>Mese prima immatricolazione
            </label>
            <select :disabled="isSelectMeseDisabled"
                :class="{ 'disabled': isSelectMeseDisabled }" v-model="mese" @change="setMese">
                <option value="">Seleziona</option>
                <option v-for="(mese, index) in mesi" :key="index" :value="mese">
                    {{ mese }}
                </option>
            </select>
        </div>
        <div class="inline-block w-full mb-[20px]">
            <label class="font-bold block mb-[5px]">
                <span class="inline-block text-center font-light w-[24px] h-[24px] mr-[3px]">4 -</span>Modello
            </label>
            <div class="w-full overflow-auto">  
                <select :disabled="isSelectModelloDisabled"
                    :class="{ 'disabled': isSelectModelloDisabled }" v-model="modello" @change="setModello" style="width: auto; min-width: 100%">
                    <option value="">Seleziona</option>
                    <option v-for="(modello, index) in modelli" :key="index" :value="modello">
                        {{ modello }} 
                    </option>
                </select>
            </div>
        </div>
        <div class="inline-block w-full mb-[20px]">
            <label class="font-bold block mb-[5px]">
                <span class="inline-block text-center font-light w-[24px] h-[24px] mr-[3px]">5 -</span>Motorizzazione
            </label>
            <div class="w-full overflow-auto">  
                <select :disabled="isSelectGammaDisabled"
                    :class="{ 'disabled': isSelectGammaDisabled }" v-model="gamma" @change="setGamma" style="width: auto; min-width: 100%">
                    <option value="">Seleziona</option>
                    <option v-for="(gamma, index) in gamme" :key="index" :value="gamma?.versioneBase?.id">
                        {{ gamma?.versioneBase?.descrizione }}
                    </option>
                </select>
            </div>
        </div>

        <div class="inline-block w-full md:w-[48%] mb-[20px]">
            <label class="font-bold block mb-[5px]">
                <span class="inline-block text-center font-light w-[24px] h-[24px] mr-[3px]">6 -</span>Percorrenza km media
            </label>
            <input type="text" class="disabled bg-[#fff]" disabled placeholder="Calcolo in corso..." v-model="percorrenzaMedia" />
        </div>
        <div class="inline-block w-full sm:w-[48%] mb-[20px]">
            <label class="font-bold block mb-[5px]">
                <span class="inline-block text-center font-light w-[24px] h-[24px] mr-[3px]">7 -</span>Percorrenza km
            </label>
            <input type="text" placeholder="Percorrenza km" v-model="percorrenzaChilometrica" />
        </div>
    </div>
    
    <div class="flex justify-end">
        <button class="button p-[15px] sm:p-[20px]" @click="submit">valutazione</button>
    </div>
</template>

<script>
import axios from 'axios';
import { mainStore } from '../../../store/main';
import formatter from "../../formatter";
import Popup from '../Popup.vue';

export default {
    name: 'RicercaAuto',

    components: { Popup },

    data() {
        return {
            mainStore,
            marche: [],
            periodi: [],
            dataPubblicazione: null,
            targa: null,
            //telaio: null,
            codiceMnet: null,
            codiceCostruttore: null,
            anni: [],
            mesi: [],
            isSelectDataDisabled: true,
            isSelectMarcaDisabled: true,
            isSelectAnnoDisabled: true,
            isSelectMeseDisabled: true,
            isSelectModelloDisabled: true,
            isSelectGammaDisabled: true,
            isPercorrenzaMediaDisabled: true,
            marca: "",
            anno: "",
            gamme: [],
            gammeFullList: [],
            modello: "",
            modelli: [],
            mese: "",
            gamma: "",
            percorrenzaMedia: "",
            percorrenzaChilometrica: "",
            valutazioni: [],
            perizia: {},
            vehicleSearched: {},
            isSavingMode: false,
            isLicensePlatesListVisible: false,
            isShellsListVisible: false,
            isEurotaxCodesListVisible: false,
            isMotornetCodesListVisible: false,
            allestimenti: [],
            codiciGamme: [],
            modelliComplete: {},
            modelliCodice: [],
            isNoDataPopupOpen: false,
            datiVeicoloNonDisponibile: {},
            isImmatricolazioneEstera: false,
            targaEstero: "",
            statoEstero: "",
            dataImmatricolazioneEstero: ""
        }
    },

    async created() {
        const loader = this.$loading.show();

        await this.getPeriodoValutazioni();
        if(this.periodi.length > 0) {
            this.dataPubblicazione = `${this.periodi[0]?.mese}/${this.periodi[0]?.anno}`;
            this.setDataPubblicazione();
        }
        await this.getMarche();

        if(this.mainStore?.datiSearchTargaTipoVeicoloSbagliato != {}) {
            this.targa = this.mainStore.datiSearchTargaTipoVeicoloSbagliato?.targa;
            this.vehicleSearched = this.mainStore.datiSearchTargaTipoVeicoloSbagliato;
            this.isLicensePlatesListVisible = true;
        }

        loader.hide();
    },

    methods: {
        resetForm() {
            this.marca = "";
            this.isSelectAnnoDisabled = true;
            this.anno = "";
            this.anni = [];
            this.isSelectMeseDisabled = true;
            this.mese = "";
            this.isSelectModelloDisabled = true;
            this.modello = "";
            this.modelli = [];
            this.isSelectGammaDisabled = true;
            this.gamma = "";
            this.gamme = [];
            this.allestimenti = [];
            this.percorrenzaChilometrica = "";
            this.percorrenzaMedia = "";
            this.targaEstero = "";
            this.statoEstero = "";
            this.dataImmatricolazioneEstero = "";
            this.isImmatricolazioneEstera = false;
        },
        onSearchCostruttore() {
            this.targa = null;
            this.codiceMnet = null;
        },
        onSearchEurotax() {
            this.targa = null;
            this.codiceCostruttore = null;
        },
        onSearchTarga() {
            this.codiceMnet = null;
            this.codiceCostruttore = null;
        },
        format(date, initialFormat, finalFormat) {
            if(!date) {
                return null;
            }
            return formatter.formatDate(date, initialFormat, finalFormat);
        },  
        setDataPubblicazione() {
            const loader = this.$loading.show();

            this.marca = "";
            this.anno = "";
            this.anni = [];
            this.isSelectAnnoDisabled = true;
            this.mese = "";
            this.isSelectMeseDisabled = true;
            this.modello = "";
            this.modelli = [];
            this.isSelectModelloDisabled = true;
            this.gamma = "";
            this.gamme = [];
            this.isSelectGammaDisabled = true;
            this.allestimenti = [];
            this.percorrenzaMedia = "";
            this.percorrenzaChilometrica = "";

            if(this.dataPubblicazione == this.periodi[0]?.mese + "/" + this.periodi[0]?.anno) {
                this.mainStore.isSendingCorrectionAvailable = true;
            } else {
                this.mainStore.isSendingCorrectionAvailable = false;
            }

            loader.hide();
        },
        async setMarca() {
            const loader = this.$loading.show();

            this.isSavingMode = false;

            this.targa = null;
            this.codiceMnet = null;
            this.codiceCostruttore = null;

            this.anno = "";
            this.mese = "";
            this.isSelectMeseDisabled = true;
            this.modello = "";
            this.modelli = [];
            this.isSelectModelloDisabled = true;
            this.gamma = "";
            this.gamme = [];
            this.isSelectGammaDisabled = true;
            this.allestimenti = [];
            this.percorrenzaMedia = "";
            this.percorrenzaChilometrica = "";

            if(!this.marca) {
                this.isSelectAnnoDisabled = true;
            } else {
                this.isSelectAnnoDisabled = true;
                await this.getAnni();
                this.isSelectAnnoDisabled = false;
            }

            loader.hide();
        },
        async setAnno() {
            const loader = this.$loading.show();

            if(this.anno) {
                this.isSelectAnnoDisabled = false;
            }
            
            if(! this.isSavingMode) {
                this.mese = "";
                this.modello= "";
                this.modelli = [];
                this.isSelectModelloDisabled = true;
                this.gamma = "";
                this.gamme = [];
                this.isSelectGammaDisabled = true;
                this.allestimenti = [];
                this.percorrenzaMedia = "";
                this.percorrenzaChilometrica = "";
     
                if(!this.anno) {
                    this.isSelectMeseDisabled = true;
                } else {
                    this.isSelectMeseDisabled = true;
                    this.getMesi();
                    this.isSelectMeseDisabled = false;
                }
            }

            if(this.anno && this.mese && this.dataPubblicazione && this.allestimenti?.length > 0) {
                await this.getPercorrenzaMedia();
            }

            loader.hide();
        },
        async setMese() {
            const loader = this.$loading.show();

            if(this.mese) {
                this.isSelectMeseDisabled = false;
            }
            
            if(! this.isSavingMode) {
                this.modello= "";
                this.gamma = "";
                this.gamme = [];
                this.isSelectGammaDisabled = true;
                this.allestimenti = [];
                this.percorrenzaMedia = "";
                this.percorrenzaChilometrica = "";
     
                if(!this.mese) {
                    this.isSelectModelloDisabled = true;
                } else {
                    this.isSelectModelloDisabled = true;
                    await this.getModelli();
                    this.isSelectModelloDisabled = false;
                }                           
            }
            
            if(this.anno && this.mese && this.dataPubblicazione && this.allestimenti?.length > 0) {
                await this.getPercorrenzaMedia();
            }

            loader.hide();
        },
        async setModello() {
            const loader = this.$loading.show();

            if(this.modello) {
                this.isSelectModelloDisabled = false;
            }

            if(! this.isSavingMode) {
                this.gamma = "";
                this.allestimenti = [];

                this.percorrenzaMedia = "";
                this.percorrenzaChilometrica = "";
                if(!this.modello) {
                    this.isSelectGammaDisabled = true;
                } else {
                    this.isSelectGammaDisabled = true;
                    this.modelliCodice = [];
                    
                    this.modelliComplete?.versioniMarca[0]?.versioni.forEach(item => {
                        if(item?.modelloBreveCarrozzeria == this.modello && !this.modelliCodice.find(b => b == item?.gammaModello?.codice)) {
                            this.modelliCodice.push(item?.gammaModello?.codice);
                        }
                    });
                   
                    await this.getGamme();
                    this.isSelectGammaDisabled = false;
                }              
            } else {
                this.isSelectGammaDisabled = false;
            }

            loader.hide();
        },
        async setGamma() {
            const loader = this.$loading.show();
            
            if(this.gamma) {
                this.isSelectGammaDisabled = false;
            }
            
            if(! this.isSavingMode) {
                this.versione = "";
                
                this.percorrenzaMedia = "";
                this.percorrenzaChilometrica = "";
                const response = await axios.get(`${process.env.VUE_APP_HOST}/${process.env.VUE_APP_VERSION}/proxy/usato/auto/versioni?id_versione_base=${this.gamma}&anno=${this.anno}&libro=false`);
                this.allestimenti = [ ...response.data?.versioni ];
            } else {
                this.isSelectVersioneDisabled = false;
            }

            if(this.anno && this.mese && this.dataPubblicazione && this.allestimenti?.length > 0) {
                await this.getPercorrenzaMedia();
            }

            loader.hide();
        },
        async saveVehicle(data) {
            const loader = this.$loading.show();

            this.percorrenzaMedia = "";

            this.isLicensePlatesListVisible = false;
            this.isShellsListVisible = false;
            this.isEurotaxCodesListVisible = false;
            this.isMotornetCodesListVisible = false;

            if(this.vehicleSearched?.immatricolazioneEstera == "si") {
                this.targaEstero = this.vehicleSearched.targaEstero;
                this.statoEstero = this.vehicleSearched?.statoEstero;
                this.dataImmatricolazioneEstero = this.format(this.vehicleSearched?.dataImmatricolazioneEstero, "YYYY-MM-DD", "DD/MM/YYYY");
                this.isImmatricolazioneEstera = true;
            } else {
                this.targaEstero = "";
                this.statoEstero = "";
                this.dataImmatricolazioneEstero = this.format(this.vehicleSearched?.dataImmatricolazioneEstero, "YYYY-MM-DD", "DD/MM/YYYY");
                this.isImmatricolazioneEstera = false;
            }

            this.isSavingMode = true;
            this.marca = data?.marca?.acronimo;

            this.modelli = [];
            this.gamme = [];

            this.modelli.push(data?.modelloBreveCarrozzeria?.descrizione);
            this.gamme.push({ versioneBase: data?.versioneBase });
            
            this.modello = this.modelli[0];
            this.gamma = this.gamme[0]?.versioneBase?.id;

            this.allestimenti = [ ...this.vehicleSearched?.versioni.map(item => {
                let versione = item;
                versione.nome = item?.versione;
                return versione;
            }) ];

            if(this.allestimenti?.length == 1) {
                this.versione = this.allestimenti[0]?.codiceMotornet;
            } else {
                this.versione = data?.codiceMnet;
            }

            this.anni = [];
            this.anno = "";
            this.mese = "";
            if(this.dataImmatricolazioneEstero) {
                this.anni = [ this.format(this.dataImmatricolazioneEstero, "DD/MM/YYYY", "YYYY") ];
                this.anno = this.format(this.dataImmatricolazioneEstero, "DD/MM/YYYY", "YYYY");
                this.mesi = [ this.format(this.dataImmatricolazioneEstero, "DD/MM/YYYY", "M") ];
                this.mese = this.format(this.dataImmatricolazioneEstero, "DD/MM/YYYY", "M");
            } else if(this.vehicleSearched?.dataImmatricolazione) {
                this.anni = [ this.format(this.vehicleSearched.dataImmatricolazione, "YYYY-MM-DD", "YYYY") ];
                this.anno = this.format(this.vehicleSearched.dataImmatricolazione, "YYYY-MM-DD", "YYYY");
                this.mesi = [ this.format(this.vehicleSearched.dataImmatricolazione, "YYYY-MM-DD", "M") ];
                this.mese = this.format(this.vehicleSearched.dataImmatricolazione, "YYYY-MM-DD", "M");
            } else {
                if(data?.fineCommercializzazione) {
                    for(let i = data?.inizioCommercializzazione?.split("-")[0]; i <= data?.fineCommercializzazione?.split("-")[0]; i++) {
                        this.anni.unshift(i);
                    }
                } else {
                    for(let i = data?.inizioCommercializzazione?.split("-")[0]; i <= new Date().getFullYear(); i++) {
                        this.anni.unshift(i);
                    }
                }

                this.getMesi();
            }            

            if(!this.anni) {
                await this.getAnni();
            }

            if(this.anno && this.mese && this.dataPubblicazione && this.allestimenti?.length > 0) {
                await this.getPercorrenzaMedia();
            }

            this.isSelectAnnoDisabled = false;
            this.isSelectMeseDisabled = false;
            this.isSelectModelloDisabled = false;
            this.isSelectGammaDisabled = false;

            //this.targa = null;
            //this.telaio = null;
            //this.codiceMnet = null;
            //this.codiceCostruttore = null;

            this.vehicleSearched = {};
            this.mainStore.datiSearchTargaTipoVeicoloSbagliato = {};
            
            document.getElementById('selection').scrollIntoView({behavior: 'smooth'});

            loader.hide();
        },
        async searchVehicle() {
            this.isLicensePlatesListVisible = false;
            //this.isShellsListVisible = false;
            this.isEurotaxCodesListVisible = false;
            this.isMotornetCodesListVisible = false;

            if(!this.targa && /*!this.telaio && */!this.codiceMnet && !this.codiceCostruttore) {
                this.$notify({
                    title: "Attenzione",
                    text: "Inserire una targa, codice Mnet o codice Eurotax o codice Costruttore",
                    type: "warn",
                });
                return;
            }

            const loader = this.$loading.show();

            this.resetForm();

            let response = null;
            try {
                if(this.targa) {
                    response = await axios.get(`${process.env.VUE_APP_HOST}/${process.env.VUE_APP_VERSION}/proxy/usato/generali/targa?targa=${this.targa}&costruttore=`);
                    
                    this.isLicensePlatesListVisible = true;
                /*} else if(this.telaio) {
                    response = await axios.get(`${process.env.VUE_APP_HOST}/${process.env.VUE_APP_VERSION}/private/generali/vin/priv?telaio=${this.telaio}&lang=IT`);

                    this.isShellsListVisible = true;*/
                } else if(this.codiceMnet) {
                    response = await axios.get(`${process.env.VUE_APP_HOST}/${process.env.VUE_APP_VERSION}/proxy/usato/auto/eurotax_mnet?codice_eurotax_mnet=${this.codiceMnet}`);

                    this.isEurotaxCodesListVisible = true;
                } else if(this.codiceCostruttore) {
                    response = await axios.get(`${process.env.VUE_APP_HOST}/${process.env.VUE_APP_VERSION}/proxy/usato/auto/costruttore?codice_costruttore=${this.codiceCostruttore}`);
                    
                    this.isMotornetCodesListVisible = true;
                }

                if(response.data?.tipoVeicolo && response.data.tipoVeicolo != "AUTOVETTURE") {
                    this.mainStore.datiSearchTargaTipoVeicoloSbagliato = { ...response.data };
                    if(response.data.tipoVeicolo == "DUE_RUOTE") {
                        this.mainStore.type = "moto";
                    } else {
                        this.mainStore.type = "vcom";
                    }
                    this.$router.push("/ricerca-modello");
                }

                if(response.data?.versioniBase?.length < 1) {
                    this.datiVeicoloNonDisponibile = {
                        targa: response.data?.targa,
                        telaio: response.data?.telaio,
                        tipo: response.data?.tipoVeicolo,
                        codiceMotore: response.data?.codiceMotore,
                        codiceOmologazione: response.data?.codiceOmologazione,
                        dataImmatricolazione: response.data?.dataImmatricolazione,
                        dataUltimaRevisione: response.data?.dataUltimaRevisione,
                        immatricolazioneEstera: response.data?.immatricolazioneEstera,
                        statoEstero: response.data?.statoEstero,
                        targaEstero: response.data?.targaEstero,
                        dataImmatricolazioneEstero: response.data?.dataImmatricolazioneEstero
                    }
                    this.isNoDataPopupOpen = true;
                    loader.hide();
                    return;
                }
                
                this.vehicleSearched = { ...response.data };
            } catch(error) {
                console.log("e", error);
                this.$notify({
                    title: "Errore nella ricerca del veicolo",
                    text: error?.response?.data?.message ? error.response.data.message : error?.response?.statusText,
                    type: "error",
                });
            }

            loader.hide();
        },
        async submit() {
            if (!this.marca || !this.anno || !this.mese || !this.modello || !this.gamma) {
                this.$notify({
                    title: "Attenzione",
                    text: "Compilare tutti i campi prima di proseguire con la valutazione",
                    type: "warn",
                });
                return;
            }

            if(this.percorrenzaChilometrica != "") {
                const reg = new RegExp(/^\d+$/);
                if(!reg.test(this.percorrenzaChilometrica)) {
                    this.$notify({
                        title: "Attenzione",
                        text: "Percorrenza km non valida: deve essere un valore numerico positivo",
                        type: "warn",
                    });
                    return;
                } else if(parseInt(this.percorrenzaChilometrica) > 0) {
                    this.percorrenzaChilometrica = parseInt(this.percorrenzaChilometrica);
                } else {
                    this.percorrenzaChilometrica = "";
                }
            }

            const loader = this.$loading.show();
            
            await this.getValutazioni();
            if(this.valutazioni?.length < 1) {
                loader.hide();
                return;
            }
            
            let perizie = [];
            
            this.valutazioni.forEach(item => {
                let perizia = {};
                perizia.valutazione = item?.valutazione?.valutazione;

                const dettagli = this.allestimenti.find(allestimento => {
                    let codice = allestimento?.codice;
                    if(allestimento?.codiceEurotax) {
                        codice = allestimento.codiceEurotax;
                    }

                    if(codice == item?.datiVeicolo?.codiceEurotax) {
                        return allestimento;
                    }
                    return false;
                })
                perizia.dettagli = { codiceEurotax: dettagli?.codice ? dettagli.codice : dettagli?.codiceEurotax, nome: dettagli?.nome, marca: { nome: dettagli?.marca?.nome },
                    modelloBreveCarrozzeria: "" }

                perizie.push(perizia);
            })
            
            let perizia = { ...perizie[0] };
            perizia.annoImmatricolazione = this.valutazioni[0]?.datiVeicolo?.annoImmatricolazione;
            perizia.meseImmatricolazione = this.valutazioni[0]?.datiVeicolo?.meseImmatricolazione;
            this.mainStore.perizia = { ...perizia };
            this.mainStore.perizie = [ ...perizie ];
            this.mainStore.kmPerizia = this.percorrenzaChilometrica != "" ? this.percorrenzaChilometrica : 0;

            this.$router.push("/perizia");

            loader.hide();
        },
        async getPeriodoValutazioni() {
            try {
                const response = await axios.get(`${process.env.VUE_APP_HOST}/${process.env.VUE_APP_VERSION}/proxy/usato/auto/valutazione/periodi`)

                this.periodi = response.data?.periodi;
                if(this.periodi?.length > 0) {
                    this.dataPubblicazione = this.periodi[0].pubblicazione;
                }
                
                this.isSelectDataDisabled = false;
            } catch(error) {
                console.log("e", error);
                this.$notify({
                    title: "Errore nel caricamento delle pubblicazioni Eurotax",
                    text: error?.response?.data?.message ? error.response.data.message : error?.response?.statusText,
                    type: "error",
                });
            }
        },
        async getMarche() {
            this.marche = [];

            try {
                const response = await axios.get(`${process.env.VUE_APP_HOST}/${process.env.VUE_APP_VERSION}/proxy/usato/auto/marche?libro=false`)
                for (const marca in response?.data?.marche) {
                    this.marche.push({ acronimo: response?.data?.marche[marca]?.acronimo, nome: response?.data?.marche[marca]?.nome });
                }
                this.isSelectMarcaDisabled = false;
            } catch(error) {
                console.log("e", error);
                this.$notify({
                    title: "Errore nel caricamento delle marche",
                    text: error?.response?.data?.message ? error.response.data.message : error?.response?.statusText,
                    type: "error",
                });
            }
        },
        async getAnni() {
            this.anni = [];

            try {
                const response = await axios.get(`${process.env.VUE_APP_HOST}/${process.env.VUE_APP_VERSION}/proxy/usato/auto/anni?codice_marca=${this.marca}`);
                
                this.anni = [ ...response.data?.anni ];
            } catch(error) {
                console.log("e", error);
                this.$notify({
                    title: "Errore nel caricamento degli anni",
                    text: error?.response?.data?.message ? error.response.data.message : error?.response?.statusText,
                    type: "error",
                });
            }
        },
        getMesi() {
            this.mesi = [];

            try {
                for(let i = 1; i < 13; i++) {
                    this.mesi.push(i);
                }
            } catch(error) {
                console.log("e", error);
                this.$notify({
                    title: "Errore nel caricamento dei mesi",
                    text: error?.response?.data?.message ? error.response.data.message : error?.response?.statusText,
                    type: "error",
                });
            }
        },
        async getModelli() {
            this.modelli = [];

            try {
                const response = await axios.post(`${process.env.VUE_APP_HOST}/${process.env.VUE_APP_VERSION}/proxy/usato/auto/versioni/lista`, {
                    marca: this.marca,
                    annoProduzioneDa: this.anno,
                    annoProduzioneA: this.anno
                }, { headers: { "content-type": "application/json" } });

                this.modelli = [ ...response.data?.modelloBreveCarrozzeria ];
                this.modelliComplete =  { ...response.data };
            } catch(error) {
                console.log("e", error);
                this.$notify({
                    title: "Errore nel caricamento dei modelli",
                    text: error?.response?.data?.message ? error.response.data.message : error?.response?.statusText,
                    type: "error",
                });
            }
        },
        async getGamme() {
            this.gamme = [];
            
            try {
                const response = await axios.post(`${process.env.VUE_APP_HOST}/${process.env.VUE_APP_VERSION}/proxy/usato/auto/versioni/base`, {
                    gammaModelloCodiceList: this.modelliCodice,
                    anno: this.anno
                }, { headers: { "content-type": "application/json" } });

                this.gamme = [ ...response.data?.versioni ];

                if(this.gamme.length == 1) {
                    this.gamma = this.gamme[0]?.versioneBase?.id;
                    await this.setGamma();
                }
            } catch(error) {
                console.log("e", error);
                this.$notify({
                    title: "Errore nel caricamento delle gamme",
                    text: error?.response?.data?.message ? error.response.data.message : error?.response?.statusText,
                    type: "error",
                });
            }
        },
        async getPercorrenzaMedia() {
            this.isPercorrenzaMediaLoading = true;
            try {
                const response = await axios.get(`${process.env.VUE_APP_HOST}/${process.env.VUE_APP_VERSION}/proxy/usato/auto/percorrenza?codice_eurotax=${this.allestimenti[0]?.codiceEurotax}&anno=${this.anno}`
                + `&mese=${this.mese}&anno_valutazione=${this.format(this.dataPubblicazione, "MM/YYYY", "YYYY")}&mese_valutazione=${this.format(this.dataPubblicazione, "MM/YYYY", "M")}`);
                
                this.percorrenzaMedia = response.data?.percorrenza ? response.data.percorrenza : "N.D.";
            } catch(error) {
                console.log("e", error);
                this.$notify({
                    title: "Errore nel calcolo della percorrenza media",
                    text: error?.response?.data?.message ? error.response.data.message : error?.response?.statusText,
                    type: "error",
                });
                this.isPercorrenzaMediaLoading = false;
            }
        },
        async getValutazioni() {
            let request = [];          

            this.allestimenti.forEach(item => {
                if(item?.codiceEurotax || item?.codice) {
                    request.push({
                        calcoloValutazione: {
                            codiceEurotax: item?.codiceEurotax ? item.codiceEurotax : item?.codice,
                            annoImmatricolazione: this.anno,
                            annoValiditaPerizia: this.dataPubblicazione.split("/")[1],
                            meseValiditaPerizia: this.dataPubblicazione.split("/")[0],
                            meseImmatricolazione: this.mese,
                            km: this.percorrenzaChilometrica,
                            ignoraVariazioneKm: false
                        },
                        cliente: {},
                        configAccessori: null,
                        danni: {},
                        datiAggiuntiviCalcolo: {
                            correzioni: {}
                        },
                        nota: "",
                        personalizzazione: {},
                        riparazioniCarrozzeria: {},
                        riparazioniMeccanica: {},
                        spese: {},
                        superValutazioni: [],
                        veicolo: {
                            annoImmatricolazione: this.anno,
                            dataImmatricolazioneEstero: this.dataImmatricolazioneEstero,
                            km: this.percorrenzaChilometrica,
                            meseImmatricolazione: this.mese,
                            targa: this.targa, 
                            targaEstero: this.targaEstero 
                        }
                    })
                }
            })

            if(request.length < 1) {
                return;
            }

            try {
                const response = await axios.post(`${process.env.VUE_APP_HOST}/${process.env.VUE_APP_VERSION}/admonline/perizia/auto/valutazioni`, request, 
                    { headers: { "content-type": "application/json" } });

                this.valutazioni = response.data;
            } catch(error) {
                console.log("e", error);
                this.$notify({
                    title: "Errore nella valutazione",
                    text: error?.response?.data?.message ? error.response.data.message : error?.response?.statusText,
                    type: "error",
                });
            }
        },
    },
}
</script>